import React from 'react';
import SignIn from './components/SignIn';
import './App.css';

function App() {
  return <SignIn />;
}

export default App;
